import { useMutation, useQueryClient } from 'react-query';
import axiosInstance from "./axiosInstant";


const moveRequest = async (msgId, label) => {
    const msgIDs = (Array.isArray(msgId)) ? msgId.join(',') : msgId;
    //console.log(msgIDs);
    const { data } = await axiosInstance.get(`/inbox/move/${label}/?id=${msgIDs}`);
    return data;
};

const useMoveMutation = () => {
    const queryClient = useQueryClient();

    // Define the mutation
    const mutation = useMutation(({msgId, label}) => moveRequest(msgId, label), {
        onSuccess: (data) => {
            //console.log('Data submitted successfully:', data);
            queryClient.invalidateQueries(['move']); // Adjust query keys as needed
        },
        onError: (error) => {
            console.error('Error submitting data:', error);
        },
    });

    // Handler function
    const moveHandle = (el, label, msgId, remove = false) => {
        if(el !== null) {
            el.preventDefault();
            if(remove)
                el.currentTarget.remove();
            else
                el.currentTarget.classList.toggle('active');
        }

        mutation.mutate({label, msgId});
    };

    return { moveHandle, mutation };
};

export default useMoveMutation;
